import React from 'react';

interface LogoSvgProps {
  className?: string;
}

const LogoSvg: React.FC<LogoSvgProps> = ({ className = "" }) => {
  return (
    <svg
      viewBox="0 0 300 120"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* AI Brain Icon */}
      <g transform="translate(10, 20)">
        {/* Brain outline */}
        <path
          d="M5 40 C5 20, 25 5, 45 10 C50 5, 65 5, 70 10 C90 5, 110 20, 110 40 C110 45, 108 50, 105 55 C108 60, 110 65, 110 70 C110 85, 95 95, 80 95 L35 95 C20 95, 5 85, 5 70 C5 65, 7 60, 10 55 C7 50, 5 45, 5 40 Z"
          fill="none"
          stroke="hsl(var(--primary))"
          strokeWidth="3"
          className="drop-shadow-lg"
        />
        
        {/* Neural connections */}
        <circle cx="25" cy="35" r="3" fill="hsl(var(--primary))" className="animate-pulse" />
        <circle cx="45" cy="25" r="3" fill="hsl(var(--primary))" className="animate-pulse" style={{animationDelay: '0.3s'}} />
        <circle cx="70" cy="30" r="3" fill="hsl(var(--primary))" className="animate-pulse" style={{animationDelay: '0.6s'}} />
        <circle cx="85" cy="45" r="3" fill="hsl(var(--primary))" className="animate-pulse" style={{animationDelay: '0.9s'}} />
        <circle cx="30" cy="55" r="3" fill="hsl(var(--primary))" className="animate-pulse" style={{animationDelay: '1.2s'}} />
        <circle cx="60" cy="50" r="3" fill="hsl(var(--primary))" className="animate-pulse" style={{animationDelay: '1.5s'}} />
        <circle cx="80" cy="65" r="3" fill="hsl(var(--primary))" className="animate-pulse" style={{animationDelay: '1.8s'}} />
        
        {/* Connection lines */}
        <line x1="25" y1="35" x2="45" y2="25" stroke="hsl(var(--primary))" strokeWidth="1.5" opacity="0.6" />
        <line x1="45" y1="25" x2="70" y2="30" stroke="hsl(var(--primary))" strokeWidth="1.5" opacity="0.6" />
        <line x1="70" y1="30" x2="85" y2="45" stroke="hsl(var(--primary))" strokeWidth="1.5" opacity="0.6" />
        <line x1="25" y1="35" x2="30" y2="55" stroke="hsl(var(--primary))" strokeWidth="1.5" opacity="0.6" />
        <line x1="60" y1="50" x2="80" y2="65" stroke="hsl(var(--primary))" strokeWidth="1.5" opacity="0.6" />
        <line x1="45" y1="25" x2="60" y2="50" stroke="hsl(var(--primary))" strokeWidth="1.5" opacity="0.6" />
        
        {/* Play button in center */}
        <polygon 
          points="48,40 48,60 68,50" 
          fill="hsl(var(--primary))" 
          className="drop-shadow-md"
        />
      </g>
      
      {/* Company Text */}
      <g transform="translate(140, 25)">
        <text 
          x="0" 
          y="25" 
          fontSize="24" 
          fontWeight="700" 
          fill="hsl(var(--foreground))"
          fontFamily="Orbitron, monospace"
          className="drop-shadow-sm"
        >
          Future
        </text>
        <text 
          x="0" 
          y="55" 
          fontSize="24" 
          fontWeight="700" 
          fill="hsl(var(--primary))"
          fontFamily="Orbitron, monospace"
          className="drop-shadow-sm"
        >
          Level
        </text>
        <line 
          x1="0" 
          y1="65" 
          x2="120" 
          y2="65" 
          stroke="hsl(var(--primary))" 
          strokeWidth="2"
          className="drop-shadow-sm"
        />
        <text 
          x="0" 
          y="80" 
          fontSize="10" 
          fill="hsl(var(--muted-foreground))"
          fontFamily="Orbitron, monospace"
          letterSpacing="2px"
        >
          AI MARKETING
        </text>
      </g>
    </svg>
  );
};

export default LogoSvg;